module.exports = __webpack_public_path__ + "static/media/30-7.5aa7d029.mp3";